module.exports = __webpack_public_path__ + "static/taruishi-d21b1eea5004175823e6a379a6b9eb72.jpg";